<script setup lang="ts">
  import { computed } from 'vue';
  import {
    NotificationHeader,
    NotificationTable,
    NotificationQuantitySelect,
    NotificationListNavigation,
    MyNotificationsFilterModal,
    CreateNotificationModal,
    EditNotificationModal,
  } from '../ui';
  import { useNotificationList } from '../model';
  import { useUserStore } from '@/entities/User';

  const userStore = useUserStore();
  const createdByFilter = computed(() => userStore.memberId ?? undefined);

  const HEADERS = [
    'Notificações',
    'Destinatários',
    'Data de Início',
    'Data Final',
    'Periodicidade',
    'Status',
    'Ações',
  ];

  const {
    notifications,
    currentPage,
    totalPages,
    totalItems,
    itemsPerPage,
    searchTerm,
    searchType,
    isFilterActive,
    orderOptions,
    headers,
    canCreateNotification,
    loading,
    loadingMore,
    hasMoreNotifications,
    isExportButtonDisabled,
    isCreateModalOpen,
    isEditModalOpen,
    editNotificationId,
    onPageChanged,
    handleQuantityChange,
    handleSearch,
    handleNotificationDeleted,
    handleFilterUpdate,
    handleCreateNotification,
    handleNotificationCreated,
    handleEditNotification,
    handleNotificationUpdated,
    handleFilterClicked,
    handleSelectedNotificationsUpdate,
    handleExportToExcel,
    handleSearchTypeChange,
    handleSortOptions,
  } = useNotificationList({
    createdBy: createdByFilter,
    headers: HEADERS,
    canCreateNotification: true,
    filterModalComponent: MyNotificationsFilterModal,
  });
</script>

<template>
  <section>
    <div>
      <NotificationHeader
        :disabled="isExportButtonDisabled"
        :can-create-notification="canCreateNotification"
        :initial-search-term="searchTerm"
        :initial-search-type="searchType"
        @search="handleSearch"
        @create-notification="handleCreateNotification"
        @search-type-change="handleSearchTypeChange"
        @export-to-excel="handleExportToExcel"
      >
        <template
          v-if="notifications.length > 0"
          #quantity
        >
          <NotificationQuantitySelect
            v-model="itemsPerPage"
            @change="handleQuantityChange"
          />
        </template>
      </NotificationHeader>
      <NotificationTable
        :order-options="orderOptions"
        :notifications="notifications"
        :current-page="currentPage"
        :total-pages="totalPages"
        :total-records="totalItems"
        :is-filter-active="isFilterActive"
        :search-term="searchTerm"
        :loading="loading"
        :headers="headers"
        @update:sort="handleSortOptions"
        @notification-deleted="handleNotificationDeleted"
        @update:filter="handleFilterUpdate"
        @filter-clicked="handleFilterClicked"
        @update:selected-notifications="handleSelectedNotificationsUpdate"
        @notification-edit="handleEditNotification"
      />
      <NotificationListNavigation
        :notifications="notifications"
        :items-per-page="itemsPerPage"
        :total-items="totalItems"
        :current-page="currentPage"
        :loading-more="loadingMore"
        :has-more-items="hasMoreNotifications"
        @page-changed="onPageChanged"
      />
    </div>

    <CreateNotificationModal
      :is-open="isCreateModalOpen"
      @update:is-open="isCreateModalOpen = $event"
      @notification-created="handleNotificationCreated"
    />

    <EditNotificationModal
      :is-open="isEditModalOpen"
      :notification-id="editNotificationId"
      @update:is-open="isEditModalOpen = $event"
      @notification-updated="handleNotificationUpdated"
    />
  </section>
</template>
